import { render } from "./App.vue?vue&type=template&id=46f54d2a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=46f54d2a&lang=css"
script.render = render

export default script